import { Notification } from "Components/Shared/Notification/Notification";
import { formatDate } from "Utils/DateUtils";
import type { NotificationDto } from "Infrastructure/Api/Api";
import { NotificationControls } from "Components/Notifications/NotificationsManagement/ManagementNotification/NotificationControls";
import { resolveTranslatableText } from "Components/Shared/Notification/utils";

type Props = {
  notification: NotificationDto;
  onEdit?: (id: string) => void;
  onRestore?: (id: string) => void;
  onDelete?: (id: string) => void;
  isDimmed?: boolean;
};

export const ManagementNotification = ({
  notification: { title, content, variant, publicID, scheduledDate },
  isDimmed = false,
  onEdit,
  onRestore,
  onDelete,
}: Props) => (
  <Notification
    withPaper
    name={resolveTranslatableText(title)}
    content={resolveTranslatableText(content)}
    isDimmed={isDimmed}
    variant={variant}
    time={formatDate(scheduledDate, true)}
    controls={
      <NotificationControls
        variant={variant}
        onEdit={onEdit ? () => onEdit(publicID) : undefined}
        onRestore={onRestore ? () => onRestore(publicID) : undefined}
        onDelete={onDelete ? () => onDelete(publicID) : undefined}
      />
    }
  />
);
